module.exports = __webpack_public_path__ + "img/windowslive.logo.319d9b9a.svg";